module.exports = __webpack_public_path__ + "media/images/github-copilot-plan_check-mark-0462e2d57d3744bda7c4b6c4d44d9b63.png";